/**
 * Phone number validation and formatting utilities
 */

/**
 * Formats a phone number to (XXX) XXX-XXXX format
 * @param input - Raw phone number input
 * @returns Formatted phone number string
 */
export function formatPhoneNumber(input: string): string {
  // Remove all non-numeric characters
  const cleaned = input.replace(/\D/g, "");

  // Don't format if empty
  if (cleaned.length === 0) return "";

  // Format based on length
  if (cleaned.length <= 3) {
    return cleaned;
  } else if (cleaned.length <= 6) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  } else if (cleaned.length <= 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  } else {
    // Limit to 10 digits
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
  }
}

/**
 * Validates a phone number (must have at least 10 digits)
 * @param phone - Phone number to validate
 * @returns true if valid, false otherwise
 */
export function validatePhoneNumber(phone: string): boolean {
  if (!phone) return false;
  const cleaned = phone.replace(/\D/g, "");
  return cleaned.length >= 10;
}

/**
 * Strips all formatting from a phone number, leaving only digits
 * @param phone - Formatted phone number
 * @returns Phone number with only digits
 */
export function stripPhoneFormatting(phone: string): string {
  return phone.replace(/\D/g, "");
}
